'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

require('./input.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Input = _react2['default'].createClass({
    displayName: 'Input',

    propTypes: {
        ref: _react2['default'].PropTypes.string,
        defaultValue: _react2['default'].PropTypes.string,
        placeholder: _react2['default'].PropTypes.string,
        className: _react2['default'].PropTypes.string,
        inputName: _react2['default'].PropTypes.string,
        error: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool]),
        errorMessage: _react2['default'].PropTypes.string,
        errorClass: _react2['default'].PropTypes.string,
        handleChange: _react2['default'].PropTypes.func,
        onKeyDown: _react2['default'].PropTypes.func,
        onBlur: _react2['default'].PropTypes.func,
        onFocus: _react2['default'].PropTypes.func,
        disabled: _react2['default'].PropTypes.bool
    },
    getDefaultProps: function getDefaultProps() {
        return {
            disabled: false,
            errorClass: 'c-red'
        };
    },
    getInitialState: function getInitialState() {
        return { error: false };
    },
    handleChange: function handleChange(event) {
        this.props.handleChange(event.target.value, event);
    },
    setDisabled: function setDisabled(val) {
        this.props.disabled = val;
    },
    setErrorMessage: function setErrorMessage(val) {
        if (typeof val === 'string') {
            this.props.errorMessage = val;
        }
    },
    render: function render() {

        var errorMsg = '';

        var divClasses = {
            'm-input': true,
            'm-input-error': this.props.error
        };
        divClasses[this.props.className] = this.props.className;
        divClasses = (0, _classnames2['default'])(divClasses);
        if (this.props.errorMessage) {
            var errorDivClasses = {
                'm-input-error-message': true
            };
            if (this.props.errorClass) {
                errorDivClasses[this.props.errorClass] = true;
            }
            errorDivClasses = (0, _classnames2['default'])(errorDivClasses);

            errorMsg = _jsx('div', {
                className: 'm-input-error'
            }, void 0, _jsx('img', {
                src: require('./error_x@2x.png'),
                className: 'm-input-error-message-img'
            }), _jsx('p', {
                className: errorDivClasses
            }, void 0, this.props.errorMessage));
        }

        return(
            //FIXME: use transferPropsTo?
            _jsx('div', {
                className: divClasses
            }, void 0, _react2['default'].createElement('input', {
                ref: this.props.ref,
                type: 'text',
                name: this.props.inputName,
                className: 'm-input-text',
                maxLength: '99',
                placeholder: this.props.placeholder,
                disabled: this.props.disabled,
                onFocus: this.props.onFocus,
                onBlur: this.props.onBlur,
                onKeyDown: this.props.onKeyDown,
                onChange: this.handleChange,
                defaultValue: this.props.defaultValue,
                tabIndex: this.props.tabIndex || 0 }), errorMsg)
        );
    }
});
module.exports = Input;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/input.jsx
 ** module id = 609
 ** module chunks = 0
 **/